//export const METHODE_BASE_URL = "https://apitest.ooredoo.dz/archers/";
export const METHODE_BASE_URL = "https://oprema.ooredoo.dz/archers/";

export const API_LOGIN = METHODE_BASE_URL + "login";
export const API_CHANGE_PASSWORD = METHODE_BASE_URL + "password";

//export const METHODE_API_BASE_URL = "https://apitest.ooredoo.dz/archers/api/";
export const METHODE_API_BASE_URL = "https://oprema.ooredoo.dz/archers/api/";

export const API_STATS_TASK = METHODE_API_BASE_URL + "dashboard/get-stats";
export const API_STATS_CATEGORIE =
  METHODE_API_BASE_URL + "dashboard/get-stats-by-categorisation";
export const API_STATS_HISTOGRAM = METHODE_API_BASE_URL + "dashboard/histogram";

export const API_LOGOUT = METHODE_API_BASE_URL + "logout";
export const API_TOKEN_INFO = METHODE_API_BASE_URL + "token-information";
export const API_NEW_PASSWORD = METHODE_API_BASE_URL + "reset-password";
export const API_UPDATE_USER = METHODE_API_BASE_URL + "update-user";
export const API_ADD_USER = METHODE_API_BASE_URL + "register";
export const API_ADD_USER_GET_LISTS = METHODE_API_BASE_URL + "register-request";
export const API_USER_BY_USERNAME = METHODE_API_BASE_URL + "user?username=";
export const API_ALL_USERS = METHODE_API_BASE_URL + "users";
export const API_ALL_ROLE = METHODE_API_BASE_URL + "roles";

export const API_LIST_TASKS = METHODE_API_BASE_URL + "tasks";
// to modify
//export const API_LIST_PAGED_TASKS =  "http://192.168.134.75:8080/archersV2/api/tasks-pagination";

export const API_LIST_PAGED_TASKS = METHODE_API_BASE_URL + "tasks/v2/";
export const API_AFFECT_TASK = METHODE_API_BASE_URL + "affect-task";
export const API_DISPATCH_TASK = METHODE_API_BASE_URL + "dispatch";
export const API_LIST_COMPANIES = METHODE_API_BASE_URL + "companies";
export const API_LIST_TASKS_BY_CATEGORY =
  METHODE_API_BASE_URL + "tasks?categorization=";
export const API_PAGED_LIST_TASKS_BY_CATEGORY =
  METHODE_API_BASE_URL + "tasks-pagination?categorization=";
export const API_LIST_CATEGORIES = METHODE_API_BASE_URL + "task-categories";
export const API_LIST_ITEMS_BY_CATEGORY =
  METHODE_API_BASE_URL + "task-category-items?category-id=";
export const API_REORDER_ITEM_CATEGORY =
  METHODE_API_BASE_URL + "reorder-item-category";
export const API_DELETE_ITEM_CAT =
  METHODE_API_BASE_URL + "delete-item-category?item-id=";
export const API_TASKS_DETAILS = METHODE_API_BASE_URL + "task-details?taskId=";

export const API_LIST_STATUS = METHODE_API_BASE_URL + "categorization"; //list categories
export const API_LIST_STATUS_BY_CATEGORY =
  METHODE_API_BASE_URL + "categorization?categorization="; //init, en cours, ....
export const API_LIST_STATUS_BY_TYPE =
  METHODE_API_BASE_URL + "all-status?category="; //item, task .....

export const API_INFO_DISPATCH = METHODE_API_BASE_URL + "dispatch";
export const API_TASK_NEXT_STATUS =
  METHODE_API_BASE_URL + "next-status?currentStatus=";
export const API_SAVE_STATUS_TASK = METHODE_API_BASE_URL + "task-status";
export const API_LIST_WILAYA = METHODE_API_BASE_URL + "wilayas";

export const API_LIST_CHEKLISTITEMS =
  METHODE_API_BASE_URL + "checklist?taskId=";
export const API_CHECKLIST_ID_DETAILS =
  METHODE_API_BASE_URL + "checklist-details?checklistId=";
export const API_UPDATE_CHECKLIST = METHODE_API_BASE_URL + "checklist-status";

export const API_DOWNLOAD_REPORT =
  METHODE_API_BASE_URL + "reporting/task-report?task-id=";

export const API_ALL_ITEMS = METHODE_API_BASE_URL + "flat-items";
export const API_ITEM_BY_ID = METHODE_API_BASE_URL + "item-details?itemId=";
export const API_ADD_ITEM = METHODE_API_BASE_URL + "item";
export const API_DELETE_ITEM = METHODE_API_BASE_URL + "delete-item?itemId=";
export const API_UPDATE_ITEM = METHODE_API_BASE_URL + "update-item";

export const API_GET_SITE_CODE = METHODE_API_BASE_URL + "sites?site-code=al1";
export const API_GET_CATEGORIES = METHODE_API_BASE_URL + "categories";
